import { Download } from "lucide-react";
import { fmtUSD, fmtDate } from "./format";

function ClientRow({ c, onOpen }) {
  const overLimit = (c.uploads_this_month ?? 0) >= (c.monthly_upload_limit ?? 3);
  return (
    <tr data-testid={`admin-client-${c.id}`} onClick={() => onOpen(c.id)}
        className="border-b border-white/5 hover:bg-[#C9A227]/5 cursor-pointer transition">
      <td className="px-4 py-3 text-white">{c.name || "—"}</td>
      <td className="px-4 py-3 text-white/70">{c.email}</td>
      <td className="px-4 py-3">
        {c.is_pro
          ? <span className="text-[#C9A227] text-xs uppercase tracking-widest">Pro</span>
          : <span className="text-white/40 text-xs uppercase tracking-widest">Free</span>}
      </td>
      <td className="px-4 py-3 text-white/70 text-right">{c.swings_count ?? 0}</td>
      <td className="px-4 py-3 text-right" data-testid={`admin-client-monthly-${c.id}`}>
        <span className={overLimit ? "text-red-400" : "text-white/70"}>
          {c.uploads_this_month ?? 0}/{c.monthly_upload_limit ?? 3}
        </span>
      </td>
      <td className="px-4 py-3 text-white/70 text-right">{c.lessons_count ?? 0}</td>
      <td className="px-4 py-3 text-[#C9A227] text-right">{fmtUSD(c.total_spent)}</td>
      <td className="px-4 py-3 text-white/50">{fmtDate(c.created_at)}</td>
      <td className="px-4 py-3 text-white/50">{fmtDate(c.last_active)}</td>
    </tr>
  );
}

export function ClientTable({ clients, total, skip, limit, q, setQ, setSkip, onOpen, onExport, exporting }) {
  return (
    <div className="mt-10">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-4">
        <h2 className="font-display text-3xl">Customers</h2>
        <div className="flex items-center gap-3">
          <input
            data-testid="admin-client-search"
            value={q}
            onChange={(e) => { setSkip(0); setQ(e.target.value); }}
            className="input-dark !w-72 !mt-0"
            placeholder="Search by name or email..."
          />
          <button data-testid="admin-export-csv" onClick={onExport} disabled={exporting}
                  className="btn-ghost !py-2.5 !px-4 text-xs flex items-center gap-2 whitespace-nowrap">
            <Download size={14} /> {exporting ? "Exporting..." : "Download CSV"}
          </button>
        </div>
      </div>
      <div className="border border-white/10 overflow-x-auto" data-testid="admin-clients-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-white/50 border-b border-white/10 bg-white/[0.02]">
              <th className="px-4 py-3 font-normal overline">Name</th>
              <th className="px-4 py-3 font-normal overline">Email</th>
              <th className="px-4 py-3 font-normal overline">Status</th>
              <th className="px-4 py-3 font-normal overline text-right">Swings</th>
              <th className="px-4 py-3 font-normal overline text-right">This Month</th>
              <th className="px-4 py-3 font-normal overline text-right">Lessons</th>
              <th className="px-4 py-3 font-normal overline text-right">Spent</th>
              <th className="px-4 py-3 font-normal overline">Joined</th>
              <th className="px-4 py-3 font-normal overline">Last Active</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 ? (
              <tr><td colSpan={9} className="px-4 py-8 text-center text-white/40" data-testid="admin-clients-empty">No clients found.</td></tr>
            ) : clients.map((c) => <ClientRow key={c.id} c={c} onOpen={onOpen} />)}
          </tbody>
        </table>
      </div>

      <div className="flex items-center justify-between mt-4 text-sm text-white/60">
        <span data-testid="admin-clients-count">{total} client{total === 1 ? "" : "s"}</span>
        <div className="flex gap-2">
          <button data-testid="admin-prev" disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - limit))}
                  className="btn-ghost !py-2 !px-4 text-xs disabled:opacity-30">Prev</button>
          <button data-testid="admin-next" disabled={skip + limit >= total} onClick={() => setSkip(skip + limit)}
                  className="btn-ghost !py-2 !px-4 text-xs disabled:opacity-30">Next</button>
        </div>
      </div>
    </div>
  );
}
